/**
 * Configuración centralizada de tipos de cliente para órdenes de trabajo
 * Contiene los tipos disponibles con su traducción
 */
export const ORDER_CLIENT_TYPES = {
    EXTERNAL: {
        value: 'EXTERNAL',
        label: 'Externo',
    },
    INTERNAL: {
        value: 'INTERNAL',
        label: 'Interno',
    },
};

/**
 * Obtiene la etiqueta traducida de un tipo de cliente
 * @param {string} type - Tipo de cliente (EXTERNAL o INTERNAL)
 * @returns {string} Etiqueta traducida del tipo de cliente
 */
export const getClientTypeLabel = (type) => {
    return ORDER_CLIENT_TYPES[type]?.label || type;
};

/**
 * Obtiene array de opciones para selectores de tipo de cliente
 * @returns {Array} Array con value y text para cada tipo de cliente
 */
export const getClientTypeOptions = () => {
    return Object.values(ORDER_CLIENT_TYPES).map((type) => ({
        value: type.value,
        text: type.label,
    }));
};
